import { supabase } from "@/integrations/supabase/client";
import type { SetupRequestPayload } from "@/types/setup/request";

/**
 * Sends a completed setup request to our team.
 *
 * No genie is provisioned here — the request drops into the #onboarding Slack
 * channel (via the public `setup-request` edge function) where the team builds
 * the genie by hand and gets back to the customer. Anonymous, no sign-up.
 */
export class SetupRequestService {
  static async submit(payload: SetupRequestPayload): Promise<void> {
    const { data, error } = await supabase.functions.invoke("setup-request", {
      body: payload,
    });

    if (error) {
      let detail = error.message || "We couldn't send your details.";
      if (data) detail += ` | Response: ${JSON.stringify(data)}`;
      throw new Error(detail);
    }
    if (!data?.success) {
      throw new Error(data?.message || "We couldn't send your details. Please try again.");
    }
  }
}
